import { render, staticRenderFns } from "./BIAwardsList.vue?vue&type=template&id=d60871ea"
import script from "./BIAwardsList.vue?vue&type=script&lang=js"
export * from "./BIAwardsList.vue?vue&type=script&lang=js"
import style0 from "./BIAwardsList.vue?vue&type=style&index=0&id=d60871ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports